// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-6646ff7a] {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
